import './IframeForm.less';
import React, {useState, useEffect} from 'react';
import TextInput from '../../../../../bootstrap/components/text-input/TextInput';
import Button from '../../../../../bootstrap/components/button/Button';
import Icon from '../../../../../bootstrap/components/icon/Icon';
import __ from '../../../../i18n';
import NumberInput from "../../../../../bootstrap/components/number-input/NumberInput";

export default function FormDialog({onDone, onCancel}) {
    const [iframeSrc, setIframeSrc] = useState(null);
    const [iframeTitle, setIframeTitle] = useState(null);
    const [iframeWidth, setIframeWidth] = useState(null);
    const [iframeHeight, setIframeHeight] = useState(null);

    const getError = () => {
        if (!iframeSrc || iframeSrc.trim() === '') {
            return __('Src cannot be empty');
        }

        if (!iframeTitle || iframeTitle.trim() === '') {
            return __('Title cannot be empty');
        }

        if (iframeWidth === null) {
            return __('Width cannot be empty');
        }

        if (iframeHeight === null) {
            return __('Height cannot be empty');
        }

        return null;
    };

    return <div className="iframe-form">
        <div className="title">
            <span className="text">Iframe</span>
            <Icon name="link"/>
        </div>

        <div className="field-name">{__('Src')}</div>
        <TextInput
            defaultValue={iframeSrc}
            onChange={setIframeSrc}
        />

        <div className="field-name">{__('Title')}</div>
        <TextInput
            defaultValue={iframeTitle}
            onChange={setIframeTitle}
        />

        <div className="group">
            <div>
                <div className="field-name">{__('Width')}</div>
                <NumberInput
                    defaultValue={iframeWidth}
                    onChange={setIframeWidth}
                    unit="px"
                    min={1}
                    step={1}
                />
            </div>
            <div>
                <div className="field-name">{__('Height')}</div>
                <NumberInput
                    defaultValue={iframeHeight}
                    onChange={setIframeHeight}
                    unit="px"
                    min={1}
                    step={1}
                />
            </div>
        </div>

        <div className="actions">
            <Button
                title={__('Cancel')}
                onClick={() => onCancel()}
                size="small"
                appearance="borderless-neutral"
            />

            <Button
                title={__('Apply')}
                onClick={() => onDone({
                    src: iframeSrc,
                    title: iframeTitle,
                    width: iframeWidth,
                    height: iframeHeight,
                })}
                size="small"
                appearance="solid-primary"
                tooltip={getError()}
                disabled={getError() !== null}
            />
        </div>
    </div>
};

